import React, { useContext, useEffect } from 'react';

import arrowBlue from 'assets/images/arrow-blue.png';
import { useGetLoansByOwner } from '../../../../services/loan/querys';
import { useGetEntitiesListByOwner } from '../../../../services/entity/querys';
import { Button } from 'antd';

interface CardEntitiesAndLoansProps {
  EntitiesViewContext: any;
  LoansViewContext: any;
  ProfileViewContext: any;
}

const CardEntitiesAndLoans = ({ EntitiesViewContext, LoansViewContext, ProfileViewContext }: CardEntitiesAndLoansProps) => {

  const { setHandlerVisible: setVisibleEntities }: any = useContext(EntitiesViewContext);
  const { setHandlerVisible: setVisibleLoans }: any = useContext(LoansViewContext);
  const { visible, setHandlerVisible: setVisibleProfile }: any = useContext(ProfileViewContext);

  const { data: loans, reexecute: reexecuteLoans } = useGetLoansByOwner();
  const { data: entities, reexecute: reexecuteEntities } = useGetEntitiesListByOwner();

  useEffect(() => {
    if (visible) {
      reexecuteLoans({ requestPolicy: 'network-only' });
      reexecuteEntities({ requestPolicy: 'network-only' });
    }
  }, [visible]);

  const openLink = (visible: 'loans' | 'entities' | 'profile') => {
    setVisibleLoans(visible === 'loans');
    setVisibleEntities(visible === 'entities');
    setVisibleProfile(visible === 'profile');
  }

  return (
    <div className='card-profile-generic'>
      <h1 className='card-title'>Entities and loans</h1>
      <div className='flex-btw mt-10'>
        <span className='title-bold'>
          <span className='bold'>{loans?.length}</span> {loans?.length === 1? 'loan': 'loans'} | {' '}
          <span className='bold'>{loans?.length}</span> open
          {/*| <span className='bold'>2</span> closed*/}
        </span>
        <Button type="link" className="body-regular link" onClick={() => openLink('loans')}>
          See all loans <img src={arrowBlue} alt='arrow' className='arrow' />
        </Button>
      </div>
      <div className='flex-btw mt-10'>
        <span className='title-bold'>
          <span className='bold'>{entities?.length}</span> {entities?.length === 1? 'entity': 'entities'}
        </span>
        <Button type="link" className="body-regular link" onClick={() => openLink('entities')}>
          See all entities <img src={arrowBlue} alt='arrow' className='arrow' />
        </Button>
      </div>
    </div>
  )
}

export default CardEntitiesAndLoans